module.exports = __webpack_public_path__ + "img/list.b03bc3ea.png";